import { Grid } from "@mui/material";
import BestIBSPanel from "./BestIBSPanel";
import React, { memo, useContext, useState, useEffect } from "react";
import SidePanelCard from "../../StyledSidePanelCard";
import OprtIBSPanel from "./OprtIBSPanel";
import { WebMapContext } from "../../../../pages/sections/web-map/WebMapGoogleMap";
import { LoadMapContext } from "../../../../pages/sections/web-map/LoadWebMap";
import { HorizontalSeparator } from "../../../styled/Tooltip.styled";
import { ToggleSwitch, ToggleTitleWrapper } from "../../../styled/ToggleTile.styled";
import { Names_For_Filter_OPs } from "../../../../constants/WebMap";

const IBSPanel = ({
  isIBSChecked,
  isIBSVisible,
  ibsSidePanelOnClick = () => { },
  onClickIBSVisibility = () => { },
  onBestIbsChange = () => { },
  ibsChartPerm,
  opIbsPerm,
  bestIbsPerm
}) => {
  const [open, setOpen] = useState(false);
  const { mapPlacement,setIBSLegendData,operatorsPermittedIBS } = useContext(WebMapContext);
  const { mapView, setCollapseSideBar, setIsIbsTableOpen, isOpMsTableOpen, setIsOpMsTableOpen } = useContext(LoadMapContext);
  const [isBestIBSChecked, setBestIBSChecked] = useState(true);
  const [isOperatorIBSChecked, setOperatorIBSChecked] = useState(false);
  const [operatorData, setOperatorData] = useState([]);
  const [selectedOperator, setOperator] = useState([]);
  
  useEffect(() => {
    const init = async () => {
      if(isIBSChecked){
        if(operatorsPermittedIBS?.length){
          setOperator(operatorsPermittedIBS[0]?.operator)
          setOperatorData(operatorsPermittedIBS);
        }
      }
    };
    init();
  }, [isIBSChecked, operatorsPermittedIBS]);

  useEffect(() => {
    if (open) setIsIbsTableOpen(true);
  }, [open]);

  useEffect(() => {
    if (open && isOpMsTableOpen) setOpen(false);
  }, [isOpMsTableOpen]);

  const handleSidePanelInSplit = () => {
    onClickIcon();
    if (mapPlacement === "right") {
      setCollapseSideBar({ rightSideBar: false, leftSideBar: true });
    } else {
      setCollapseSideBar({ rightSideBar: true, leftSideBar: false });
    }
  };

  const onClickIcon = () => {
    setIsOpMsTableOpen(false);
    setOpen(!open);
  };

  const handleBestIBSChange = (checked) => {
    setBestIBSChecked(checked);
    onBestIbsChange(checked);
    setOperatorIBSChecked(!checked);
    setIBSLegendData([])
  };

  const handleOperatorIBSChange = (checked) => {
    setOperatorIBSChecked(checked);
    onBestIbsChange(!checked);
    setBestIBSChecked(!checked);
    setIBSLegendData([])
  };

  return (
    <>
      <SidePanelCard
        title="IBS"
        icon={isIBSChecked ? "/assets/ibsIconActive.png" : "/assets/ibsIcon.png"}
        nonShow={true}
        clicked={isIBSChecked}
        onClick={ibsSidePanelOnClick}
        isVisibleAsGreen={true}
        visibilityClicked={isIBSVisible}
        onClickVisibility={onClickIBSVisibility}
        iconInfo={{
          icon: isIBSChecked ? "/assets/searchDataIconActive.png" : "/assets/searchDataIcon.png",
          showIcon: ibsChartPerm?.is_enable && !isBestIBSChecked && opIbsPerm?.is_enable === true,
          onClickIcon: () => { mapView === null ? onClickIcon() : handleSidePanelInSplit() }
        }}
      />
      <Grid container item style={{ justifyContent: "space-between", textAlign: "left", padding: isIBSChecked ? "10px" : "0px",}}>
        {isIBSChecked && bestIbsPerm?.is_enable === true && (
          <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <ToggleTitleWrapper main>Best Operator</ToggleTitleWrapper>
            <ToggleSwitch checked={isBestIBSChecked} onChange={(e) => handleBestIBSChange(e.target.checked)} />
          </div>
        )
        }

        {isBestIBSChecked && bestIbsPerm?.is_enable === true && (
          <BestIBSPanel isIBSChecked={isIBSChecked} isIBSVisible={isIBSVisible} />
        )}

        {isIBSChecked && bestIbsPerm?.is_enable === true && opIbsPerm?.is_enable === true ? <HorizontalSeparator /> : <></>}
        {isIBSChecked && opIbsPerm?.is_enable === true && (
          <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <ToggleTitleWrapper main>Operator Performance</ToggleTitleWrapper>
            <ToggleSwitch checked={isOperatorIBSChecked} onChange={(e) => handleOperatorIBSChange(e.target.checked)} />
          </div>
        )
        }

        {isOperatorIBSChecked && opIbsPerm?.is_enable === true && (
          <>
            <OprtIBSPanel isIBSChecked={isIBSChecked} isIBSVisible={isIBSVisible} open={open} setOpen={setOpen} operatorData={operatorData} selectedOperator={selectedOperator}/>
          </>
        )}
      </Grid>
    </>
  );
};

export default memo(IBSPanel);
